export default {
  dates: {
    display: 'flex',
  },
};
